import type { IconType } from '@liscio/ui';

export const DASHBOARD_ACTION_IDS = [
  'upload_file',
  'smart_tax_delivery',
  'smart_tax_organizer',
  'send_message',
] as const;

export type DashboardActionId = (typeof DASHBOARD_ACTION_IDS)[number];

export interface DashboardAction {
  id: DashboardActionId;
  title: string;
  description: string;
  ctaLabel: string;
  icon: IconType;
  onActivate: () => void;
}

export interface BuildDashboardActionsParams {
  onUploadFile: () => void;
  onSmartTaxDelivery: () => void;
  onSmartTaxOrganizer: () => void;
  onSendMessage: () => void;
}

export function isDashboardActionId(value: string): value is DashboardActionId {
  return DASHBOARD_ACTION_IDS.some((actionId) => actionId === value);
}

export function buildDashboardActions({
  onUploadFile,
  onSmartTaxDelivery,
  onSmartTaxOrganizer,
  onSendMessage,
}: BuildDashboardActionsParams): DashboardAction[] {
  return [
    {
      id: 'upload_file',
      title: 'File Intelligence',
      description: 'Reads, classifies, and renames accounting documents in seconds.',
      ctaLabel: 'Try it',
      icon: 'uploadFile',
      onActivate: onUploadFile,
    },
    {
      id: 'smart_tax_delivery',
      title: 'Tax Delivery',
      description:
        'Guides clients through their return, places the signature blocks, shows them what to pay.',
      ctaLabel: 'Try it',
      icon: 'taxDoc',
      onActivate: onSmartTaxDelivery,
    },
    {
      id: 'smart_tax_organizer',
      title: 'Tax Organizers',
      description: 'Personalizes, auto-reminds, and matches docs as they arrive.',
      ctaLabel: 'Try it',
      icon: 'folderOpen',
      onActivate: onSmartTaxOrganizer,
    },
    {
      id: 'send_message',
      title: 'Messages',
      description: 'Send secure messages and requests to clients in one place.',
      ctaLabel: 'Try it',
      icon: 'comment',
      onActivate: onSendMessage,
    },
  ];
}
